import { USER_REQUEST, USER_ERROR, USER_SUCCESS, UPDATE_CONTENT, UPDATE_SUCCESS, UPDATE_ERROR, COGNITO_UPDATE_ERROR, COGNITO_UPDATE_REQUEST } from '../actions/user'
import api from '@/utils/api'
import routes from '@/router'

const state = {
	content:[],
	status: String,
	updateStatus: String,
	errorMessage: String,
	cognitoErrorStatus: String,
	cognitoErrorMessage: String
}

const getters = {
	userStatus: state => state.status,
	getUserErrorMessage: state => state.errorMessage.message,
	getCognitoErrorStatus: state => state.cognitoErrorStatus,
	getCognitoErrorMessage: state => state.cognitoErrorMessage,
	isAuthenticated: state => !!(state.status === 'success'),
	getContent: state => state.content,
}

const actions = {
	[USER_REQUEST]:({commit}) => {
		
		let url = `content?repository=${routes.app.$route.query.repository}`
		
		api({ url: url  })
		.then(response =>  {				
			commit(USER_SUCCESS, response)
		} )				
		.catch(error => {
			commit(USER_ERROR, error)
		});
			
			
		commit(USER_REQUEST)
	},

	[UPDATE_CONTENT]: ({ commit }, payload) => {
		commit(COGNITO_UPDATE_REQUEST)
		let data = payload
		data.repositoryName = routes.app.$route.params.repoName
		
		api({url: "commit", data:  data, method: 'POST' })
			.then(response =>  {
				if ( response.data.code ){
					commit(COGNITO_UPDATE_ERROR, response.data.message);
					return
				}

				
				commit(UPDATE_SUCCESS)
				
			} )				
			.catch(error => {
				commit(UPDATE_ERROR, error)
			});
		
	}
}

const mutations = {
	[USER_REQUEST]: (state) => {
		state.status = 'loading'
	},

	[USER_SUCCESS]: (state, payload) => {
		state.status = 'success'		
		state.content = payload.data
		state.statusMessage = payload.data
	},

	[USER_ERROR]: (state, error) => {
		state.status = 'error'
		state.errorMessage = error.response
	},

	[UPDATE_SUCCESS]: ( state ) => {
		state.cognitoErrorStatus = 'success'
		state.cognitoErrorMessage = 'form has been saved'
	},

	[UPDATE_ERROR]: ( state , payload) => {
		state.status = 'error'
		state.errorMessage = payload
	},

	[COGNITO_UPDATE_ERROR]: ( state , payload) => {
		state.cognitoErrorStatus = 'success'
		state.cognitoErrorMessage = payload
	},

	[COGNITO_UPDATE_REQUEST]: ( state ) => {
		state.cognitoErrorStatus = 'loading'
	}

	

}

export default {
	state,
	getters,
	actions,
	mutations,
}
 